import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './logout.component.html',
  styleUrl: './../login/login.component.scss',
})
export class LogoutComponent {
  constructor(private authService: AuthService) {
    this.authService.logout();
  }
}
